import EventEmitter from 'events'

export default class SportsbookBroadcaster extends EventEmitter {
  subscribe (sportsbookId, sportsbookDispatcher) {
    return this.addListener(
      sportsbookId,
      sportsbookDispatcher
    )
  }

  unsubscribe (sportsbookId, sportsbookDispatcher) {
    return this.removeListener(
      sportsbookId,
      sportsbookDispatcher
    )
  }

  broadcast (sportsbookId, action) {
    return this.emit(
      sportsbookId,
      action
    )
  }

  broadcastAll (action) {
    for (const sportsbookId of this.eventNames()) {
      this.emit(
        sportsbookId,
        action
      )
    }

    return true
  }
}
